import { ApiService } from "./ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface DelhiveryShippingCostParams {
    billingMode: string;
    destinationPinCode: string;
    originPinCode: string;
    paymentMode: string;
    status: string;
    weight: number;
}

export interface DelhiveryShippingCostResult {
    total_amount: number;
    gross_amount: number;
    charge_DTO: number;
    charge_COD: number;
    tax_data: { SGST: number; CGST: number; IGST: number };
    zone: string;
    charged_weight: number;
    status: string;
}

export const DelhiveryApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        calculateShippingCost: builder.query<DelhiveryShippingCostResult[], DelhiveryShippingCostParams>({
            query: ({ billingMode, destinationPinCode, originPinCode, paymentMode, status, weight }) => ({
                url: `/shipping/delhivery/calculate-shipping-cost`,
                method: 'GET',
                params: { billingMode, destinationPinCode, originPinCode, paymentMode, status, weight },
            }),
            transformResponse: (res: ResultsDTO<DelhiveryShippingCostResult[] | string>) => {
                const raw = res.results;
                if (typeof raw === 'string') {
                    try { return JSON.parse(raw) as DelhiveryShippingCostResult[]; } catch { return []; }
                }
                return raw ?? [];
            },
        }),
    })
});

export const { useCalculateShippingCostQuery } = DelhiveryApiSlice;
